module.exports = __webpack_public_path__ + "static/img/grda02.bf96da32.png";